import React from "react";
import { useFormContext, useController } from "react-hook-form";

import { AsyncDropdown } from "./AsyncDropdown";
import { IDropdownOption, InputErrorMessage } from "components/atoms";

export interface PaziaAsyncDropdownProps {
  name: string;
  required?: boolean;
  label?: string;
  className?: string;
  key?: React.Key;
  loadOnRender?: boolean;
  disabled?: boolean;
  isClearable?: boolean;
  isMulti?: boolean;
  onChange?: (val: IDropdownOption) => void; // TODO IDropdownOption[] if isMulti
  loadOptions: (inputValue: string) => Promise<IDropdownOption[]>;
}

export const PaziaAsyncDropdown = ({
  label,
  name,
  required,
  className,
  loadOnRender,
  disabled,
  isMulti,
  loadOptions,
  isClearable,
  onChange,
}: PaziaAsyncDropdownProps): JSX.Element => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (opt: any) => {
    if (isMulti) {
      const optValues = opt.map((x: IDropdownOption) => x.value);
      field.onChange(optValues);
      if (onChange) onChange(opt);
    } else {
      field.onChange(opt?.value ?? {});
      // if (onChange) onChange(opt); TODO Broken
    }
  };

  return (
    <div className={className ?? ""}>
      <AsyncDropdown
        label={label}
        name={name}
        loadOnRender={loadOnRender}
        value={field.value}
        onChange={onChangeHandler}
        isMulti={isMulti}
        className={className}
        disabled={disabled}
        isClearable={isClearable}
        loadOptions={loadOptions}
        required={required}
      />
      <InputErrorMessage name={name} />
    </div>
  );
};
